"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Mqtt(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M22 0c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0zm0 2H2v20h20V2zM4.186 9.068l1.11 3.463 1.108-3.463h1.58v4.977H6.782v-1.163l.114-2.378-1.202 3.541H4.9L3.692 10.5l.118 2.382v1.163h-1.2V9.068h1.575zm13.187.926h-1.494v4.051H14.68v-4.05h-1.467v-.927h4.16v.926zM10.789 9c.422 0 .8.101 1.13.301.33.201.585.486.768.857.184.37.278.793.28 1.272v.23c0 .46-.076.861-.229 1.205a2.079 2.079 0 0 1-.633.824l.803.637-.742.63-1.068-.862a2.374 2.374 0 0 1-.3.02c-.425 0-.802-.099-1.13-.294a2.006 2.006 0 0 1-.768-.842c-.183-.363-.277-.783-.285-1.257v-.264c0-.488.09-.92.27-1.29.177-.372.433-.659.765-.862.33-.204.711-.305 1.14-.305zm11.05.068v.926h-1.493v4.051h-1.2v-4.05H17.68v-.927h4.16zm-11.05.871c-.316 0-.555.127-.715.381-.158.252-.24.623-.242 1.11v.23c0 .49.082.865.242 1.125.162.262.402.393.723.393a.78.78 0 0 0 .701-.387c.164-.258.246-.627.248-1.11v-.23c0-.494-.082-.869-.248-1.127a.793.793 0 0 0-.709-.385z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Mqtt;
